module.exports = __webpack_public_path__ + "static/media/u40_premium_contract3.a3b97b6b.webp";